import { render } from "./TimeControlRenderer.vue?vue&type=template&id=f292659a&ts=true"
import script from "./TimeControlRenderer.vue?vue&type=script&lang=ts"
export * from "./TimeControlRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__